import safeLocalStorage from 'providers/safeLocalStorageProvider';
import { namespacedConsts } from 'utils/object';
import { MAX_SESSION_DURATION } from 'organizedByType/stores/userStore';

const SECONDS_TO_SHOW_COOKIE_DISCLAIMER = 8;
const HIDE_COOKIE_DISCLAIMER_STORAGE_KEY = "cookie_disclaimer_hide";
const HIDE_COOKIE_DISCLAIMER_FOR_SESSION_STORAGE_KEY = "cookie_disclaimer_hide_for_session"
export const cookieDisclaimerActionTypes = namespacedConsts({
  COOKIE_DISCLAIMER: {
    GET_DONT_SHOW_FLAG: true,
    TIME: {
      UPDATE: true,
      START_INTERVAL: true
    },
    CLOSE: {
      FOREVER: true,
      UNTIL_RELOAD: true
    }
  }
});

function runTimer(dispatch, getState){
  const { intervalId, runningTime: secondsRunning } = getState().cookieDisclaimer
  if (secondsRunning < SECONDS_TO_SHOW_COOKIE_DISCLAIMER) {
    dispatch({
      type: cookieDisclaimerActionTypes.COOKIE_DISCLAIMER.TIME.UPDATE,
      state: {
        runningTime: secondsRunning + 1
      }
    })
  }
  else {
    dispatch({
      type: cookieDisclaimerActionTypes.COOKIE_DISCLAIMER.CLOSE.UNTIL_RELOAD,
      state: {
        hide: true
      }
    })
    safeLocalStorage.setWithExpiration(HIDE_COOKIE_DISCLAIMER_FOR_SESSION_STORAGE_KEY, true, MAX_SESSION_DURATION )
    clearInterval(intervalId);
  }
}

export function cookieDisclaimerGetHideFlag(){
  return (dispatch, getState) => {
    const flagDate = safeLocalStorage.getWithExpiration(HIDE_COOKIE_DISCLAIMER_FOR_SESSION_STORAGE_KEY);
    let hide = !!flagDate && !!flagDate.data && !flagDate.isExpired || !!safeLocalStorage.get(HIDE_COOKIE_DISCLAIMER_STORAGE_KEY);
    dispatch({
      type: cookieDisclaimerActionTypes.COOKIE_DISCLAIMER.GET_DONT_SHOW_FLAG,
      state: {
        hide,
        isInitialized: true
      }
    })
    if (!hide) {
      dispatch({
        type: cookieDisclaimerActionTypes.COOKIE_DISCLAIMER.TIME.START_INTERVAL,
        state: {
          intervalId: setInterval(runTimer.part(dispatch, getState), 1000)
        }
      })
    }
  }
}

export function closeCookieDisclaimerForever(intervalId){
  return dispatch => {
    dispatch({
      type: cookieDisclaimerActionTypes.COOKIE_DISCLAIMER.CLOSE.FOREVER,
      state: {
        hide: true
      }
    })
    safeLocalStorage.set(HIDE_COOKIE_DISCLAIMER_STORAGE_KEY, true)
    clearInterval(intervalId);
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/cookieDisclaimer/cookieDisclaimerActions.js